<div class="container-fluid py-3">
  <div class="card main-card border-0">
    <div class="card-header main-header">
      <div
        class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3"
      >
        <div>
          <h4 class="page-title">Administración de usuarios</h4>

          <p class="page-description">
            Gestiona los usuarios y sus configuraciones dentro del sistema.
          </p>
        </div>

        <!-- ACCIONES -->

        <div class="header-actions">
          <button
            type="button"
            class="btn btn-light action-btn import-btn"
            (click)="openModalContent(importUsers)"
          >
            <i class="fa-solid fa-file-excel"></i>

            <span> Importar usuarios </span>
          </button>

          <button
            type="button"
            class="btn btn-primary action-btn"
            (click)="openModal(createUser, 'add', 'Agregar Usuario')"
          >
            <i class="fa-solid fa-plus"></i>

            <span> Agregar usuario </span>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body main-body">
      <div class="search-section">
        <form [formGroup]="searchForm" class="search-form">
          <div class="search-box">
            <span class="search-icon">
              <i class="fa-solid fa-magnifying-glass"></i>
            </span>

            <input
              type="text"
              class="form-control search-input"
              placeholder="Buscar por nombre, usuario o correo"
              formControlName="search"
            />

            <button
              type="button"
              class="btn search-button"
              (click)="searchUser()"
            >
              <i class="fa-solid fa-magnifying-glass"></i>

              <span> Buscar </span>
            </button>
          </div>
        </form>
      </div>

      <!-- ================================================== -->
      <!-- TABLA -->
      <!-- ================================================== -->

      <div class="table-section">
        <app-paginacion
          [currentPage]="currentPage"
          [totalItems]="totalItems"
          [selectedPageSize]="pageSize"
          [paginatedData]="currentItems"
          [headers]="tableHeaders"
          [actions]="customActions"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          [loading]="spinner"
        >
        </app-paginacion>
      </div>
    </div>
  </div>
</div>

<!-- ============================================================ -->
<!-- MODAL CREAR / EDITAR USUARIO -->
<!-- ============================================================ -->

<ng-template #createUser let-modal>
  <!-- HEADER -->

  <div class="modal-header custom-modal-header">
    <div class="modal-heading">
      <div class="modal-icon">
        <i class="fa-solid fa-user"></i>
      </div>

      <div>
        <h4 class="modal-title">
          {{ title }}
        </h4>

        <p class="modal-description">Completa la información del usuario.</p>
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <!-- BODY -->

  <div class="modal-body custom-modal-body">
    <form [formGroup]="userForm" class="needs-validation">
      <div class="row g-3">
        <!-- ================================================== -->
        <!-- USERNAME -->
        <!-- ================================================== -->

        <div class="col-12">
          <div class="field-group">
            <label for="username" class="form-label">
              Nombre de usuario
              <span class="required-mark">*</span>
            </label>

            <div class="input-icon-wrapper">
              <i class="fa-solid fa-user"></i>

              <input
                type="text"
                id="username"
                formControlName="username"
                class="form-control"
                placeholder="Ingrese el nombre de usuario"
                [readonly]="isLdap"
              />
            </div>

            <app-error-message
              [control]="userForm.get('username')"
              errorKey="required"
              message="El nombre de usuario es requerido."
            >
            </app-error-message>

            <app-error-message
              [control]="userForm.get('username')"
              errorKey="minlength"
              message="El nombre de usuario debe tener al menos 3 caracteres."
            >
            </app-error-message>

            <app-error-message
              [control]="userForm.get('username')"
              errorKey="onlyLetters"
              message="El campo solo permite letras y espacios en blanco."
            >
            </app-error-message>
          </div>
        </div>

        <!-- ================================================== -->
        <!-- NOMBRES -->
        <!-- ================================================== -->

        <div class="col-12 col-md-6">
          <div class="field-group">
            <label for="firstName" class="form-label">
              Nombres
              <span class="required-mark">*</span>
            </label>

            <div class="input-icon-wrapper">
              <i class="fa-solid fa-id-card"></i>

              <input
                type="text"
                id="firstName"
                formControlName="firstName"
                class="form-control"
                placeholder="Ingrese los nombres"
                [readonly]="isLdap"
              />
            </div>

            <app-error-message
              [control]="userForm.get('firstName')"
              errorKey="required"
              message="El campo Nombres es requerido."
            >
            </app-error-message>

            <app-error-message
              [control]="userForm.get('firstName')"
              errorKey="minlength"
              message="El campo Nombres debe tener al menos 3 caracteres."
            >
            </app-error-message>

            <app-error-message
              [control]="userForm.get('firstName')"
              errorKey="onlyLetters"
              message="El campo solo permite letras y espacios en blanco."
            >
            </app-error-message>
          </div>
        </div>

        <!-- ================================================== -->
        <!-- APELLIDOS -->
        <!-- ================================================== -->

        <div class="col-12 col-md-6">
          <div class="field-group">
            <label for="lastName" class="form-label">
              Apellidos
              <span class="required-mark">*</span>
            </label>

            <div class="input-icon-wrapper">
              <i class="fa-solid fa-id-card"></i>

              <input
                type="text"
                id="lastName"
                formControlName="lastName"
                class="form-control"
                placeholder="Ingrese los apellidos"
                [readonly]="isLdap"
              />
            </div>

            <app-error-message
              [control]="userForm.get('lastName')"
              errorKey="required"
              message="El campo Apellidos es requerido."
            >
            </app-error-message>

            <app-error-message
              [control]="userForm.get('lastName')"
              errorKey="minlength"
              message="El campo Apellidos debe tener al menos 3 caracteres."
            >
            </app-error-message>

            <app-error-message
              [control]="userForm.get('lastName')"
              errorKey="onlyLetters"
              message="El campo solo permite letras y espacios en blanco."
            >
            </app-error-message>
          </div>
        </div>

        <!-- ================================================== -->
        <!-- EMAIL -->
        <!-- ================================================== -->

        <div class="col-12">
          <div class="field-group">
            <label for="email" class="form-label">
              Correo electrónico
              <span class="required-mark">*</span>
            </label>

            <div class="input-icon-wrapper">
              <i class="fa-solid fa-envelope"></i>

              <input
                type="email"
                id="email"
                formControlName="email"
                class="form-control"
                placeholder="usuario@ejemplo.com"
                [readonly]="isLdap"
              />
            </div>

            <app-error-message
              [control]="userForm.get('email')"
              errorKey="required"
              message="El correo de usuario es requerido."
            >
            </app-error-message>

            <app-error-message
              [control]="userForm.get('email')"
              errorKey="email"
              message="El campo a ingresar debe ser un correo."
            >
            </app-error-message>
          </div>
        </div>

        <!-- ================================================== -->
        <!-- TIPO GRUPO -->
        <!-- ================================================== -->

        <div class="col-12">
          <div class="field-group">
            <label class="form-label">
              Tipo de grupo
              <span class="required-mark">*</span>
            </label>

            <div class="select-icon-wrapper">
              <i class="fa-solid fa-users"></i>

              <select
                class="form-select"
                formControlName="tipoGrupo"
                [disabled]="isLdap"
              >
                <option value="">Seleccione una opción</option>

                <option value="INT">Interno</option>

                <option value="EXT">Externo</option>
              </select>
            </div>

            <app-error-message
              [control]="userForm.get('tipoGrupo')"
              errorKey="required"
              message="El tipo de grupo es obligatorio"
            >
            </app-error-message>
          </div>
        </div>

        <!-- ================================================= -->
        <!-- VISIBILIDAD -->
        <!-- ================================================= -->

        <div
          class="visibility-section"
          [class.public-mode]="userForm.get('publica')?.value"
          *ngIf="accesUser"
        >
          <div class="visibility-info">
            <!-- ICONO -->

            <div class="visibility-icon">
              <i
                class="fa-solid"
                [ngClass]="
                  userForm.get('publica')?.value ? 'fa-globe' : 'fa-lock'
                "
              >
              </i>
            </div>

            <!-- TEXTO -->

            <div>
              <div class="visibility-title">
                Visibilidad

                <span
                  class="visibility-badge"
                  [class.badge-public]="userForm.get('publica')?.value"
                  [class.badge-private]="!userForm.get('publica')?.value"
                >
                  {{ userForm.get("publica")?.value ? "Pública" : "Privada" }}
                </span>
              </div>

              <small class="visibility-description">
                {{
                  userForm.get("publica")?.value
                    ? "Esta usuario podrá ser visto por otros usuarios."
                    : "Esta usuario solo estará disponible para su propietario."
                }}
              </small>
            </div>
          </div>

          <!-- SWITCH -->

          <label class="modern-switch">
            <input type="checkbox" id="publica" formControlName="publica" />

            <span class="slider"></span>
          </label>
        </div>
      </div>
    </form>
  </div>

  <!-- FOOTER -->

  <div class="modal-footer custom-modal-footer">
    <button
      type="button"
      class="btn btn-light secondary-button"
      (click)="modal.close('Save click')"
    >
      Cerrar
    </button>

    <button
      type="button"
      [disabled]="userForm.invalid"
      *ngIf="addUser"
      class="btn btn-primary primary-button"
      (click)="CreateUser()"
    >
      <i class="fa-solid fa-floppy-disk me-2"></i>

      Guardar
    </button>

    <button
      type="button"
      class="btn btn-primary primary-button"
      [disabled]="userForm.invalid"
      *ngIf="udpUser"
      (click)="updateUser()"
    >
      <i class="fa-solid fa-pen me-2"></i>

      Editar
    </button>
  </div>
</ng-template>

<!-- ============================================================ -->
<!-- MODAL IMPORTAR USUARIOS -->
<!-- ============================================================ -->

<ng-template #importUsers let-modal>
  <div class="modal-header custom-modal-header">
    <div class="modal-heading">
      <div class="modal-icon modal-icon-green">
        <i class="fa-solid fa-file-excel"></i>
      </div>

      <div>
        <h4 class="modal-title">
          {{ title }}
        </h4>

        <p class="modal-description">Importa usuarios desde un archivo.</p>
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal-body">
    <app-import-users></app-import-users>
  </div>

  <div class="modal-footer custom-modal-footer">
    <button
      type="button"
      class="btn btn-light secondary-button"
      (click)="modal.close('Save click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>

<!-- ============================================================ -->
<!-- MODAL GRUPOS -->
<!-- ============================================================ -->

<ng-template #userGroupsModal let-modal>
  <div class="modal-header custom-modal-header">
    <div class="modal-heading">
      <div class="modal-icon modal-icon-purple">
        <i class="fa-solid fa-users"></i>
      </div>

      <div>
        <h4 class="modal-title">
          {{ title }}
        </h4>

        <p class="modal-description">
          Administra los grupos asociados al usuario.
        </p>
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal-body">
    <!-- ================================================== -->
    <!-- CERTIFICADOS -->
    <!-- ================================================== -->

    <div class="modal-section">
      <div class="section-heading">
        <div>
          <h6 class="section-title">Seleccionar certificado</h6>

          <p class="section-description">
            Selecciona el certificado al que quieres asociar el grupo.
          </p>
        </div>
      </div>

      <div class="custom-table-wrapper table-responsive">
        <table class="table custom-table align-middle mb-0">
          <caption class="visually-hidden">
            Crear Usuario
          </caption>

          <thead>
            <tr>
              <th scope="col">Scratchcard</th>

              <th scope="col">Nombre</th>

              <th scope="col">Vencimiento</th>

              <th scope="col" class="text-center">Seleccionar</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="!certificados || certificados.length == 0">
              <td colspan="4">
                <div class="empty-state">
                  <i class="fa-solid fa-certificate"></i>

                  <span> Este usuario no tiene certificados asignados. </span>
                </div>
              </td>
            </tr>

            <tr *ngFor="let cert of certificados; index as i">
              <td>
                {{ cert.scratchcard }}
              </td>

              <td>
                {{ cert.nombre }}
              </td>

              <td>
                {{ cert.fechaVigencia }}
              </td>

              <td class="text-center">
                <input
                  type="radio"
                  class="custom-radio"
                  (click)="seleccionarCertificado(cert.id)"
                  name="certificadosUsuario"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ================================================== -->
    <!-- ASIGNAR GRUPO -->
    <!-- ================================================== -->

    <div class="modal-section" *ngIf="certificadoId">
      <div class="section-heading">
        <div>
          <h6 class="section-title">Asignar grupo</h6>

          <p class="section-description">
            Selecciona el grupo que deseas agregar a este usuario.
          </p>
        </div>
      </div>

      <div class="assignment-box">
        <div class="assignment-control">
          <app-groups class="w-100" (idGroup)="groupChange($event)">
          </app-groups>
        </div>

        <button
          type="button"
          class="btn add-circle-button"
          (click)="asignarUsuarioGrupo()"
          title="Asignar grupo"
        >
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>
    </div>

    <!-- ================================================== -->
    <!-- GRUPOS ASIGNADOS -->
    <!-- ================================================== -->

    <div class="modal-section" *ngIf="certificadoId">
      <div class="section-heading">
        <div>
          <h6 class="section-title">Grupos asignados</h6>

          <p class="section-description">
            Grupos a los que pertenece este usuario actualmente.
          </p>
        </div>
      </div>

      <div class="custom-table-wrapper table-responsive">
        <table class="table custom-table align-middle mb-0">
          <caption class="visually-hidden">
            Usuario Grupos
          </caption>

          <thead>
            <tr>
              <th scope="col">Grupo</th>

              <th scope="col">Nombre certificado</th>

              <th scope="col">Scratchcard</th>

              <th scope="col">Vigencia</th>

              <th scope="col">Fecha creación</th>

              <th scope="col" class="text-center">Acción</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let grupoUsuario of gruposUsuario; index as i">
              <td>
                {{ grupoUsuario?.grupo?.nombre }}
              </td>

              <td>
                {{ grupoUsuario?.certificado?.nombre }}
              </td>

              <td>
                {{ grupoUsuario?.certificado?.scratchcard }}
              </td>

              <td>
                {{ grupoUsuario?.certificado?.fechaVigencia }}
              </td>

              <td>
                {{ grupoUsuario?.certificado?.createdAt }}
              </td>

              <td class="text-center">
                <button
                  type="button"
                  class="btn delete-circle-button"
                  (click)="removeAsignacionGrupo(grupoUsuario.id)"
                  title="Eliminar asignación"
                >
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer custom-modal-footer">
    <button type="button" class="btn btn-success success-button">
      <i class="fa-solid fa-check me-2"></i>

      Guardar
    </button>

    <button
      type="button"
      class="btn btn-light secondary-button"
      (click)="modal.close('Save click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>

<!-- ============================================================ -->
<!-- MODAL ROLES Y PERMISOS -->
<!-- ============================================================ -->

<ng-template #userRolesAndPermissions let-modal>
  <div class="modal-header custom-modal-header">
    <div class="modal-heading">
      <div class="modal-icon modal-icon-purple">
        <i class="fa-solid fa-user-shield"></i>
      </div>

      <div>
        <h4 class="modal-title">
          {{ title }}
        </h4>

        <p class="modal-description">
          Administra los roles asignados al usuario.
        </p>
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal-body">
    <!-- ================================================== -->
    <!-- ASIGNAR ROL -->
    <!-- ================================================== -->

    <div class="modal-section">
      <div class="section-heading">
        <div>
          <h6 class="section-title">Asignar rol</h6>

          <p class="section-description">
            Selecciona el rol que deseas agregar a este usuario.
          </p>
        </div>
      </div>

      <form [formGroup]="rolForm" class="role-form">
        <div class="role-selector">
          <div class="select-icon-wrapper flex-grow-1">
            <i class="fa-solid fa-shield-halved"></i>

            <select class="form-select" formControlName="rolId">
              <option value="">Seleccione un rol</option>

              <option
                *ngFor="let rol of roles; index as i"
                value="{{ rol.id }}"
              >
                {{ rol.nombre }}
              </option>
            </select>
          </div>

          <button
            type="button"
            class="btn add-circle-button"
            (click)="asignarRole()"
            title="Agregar rol"
          >
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
      </form>
    </div>

    <!-- ================================================== -->
    <!-- ROLES ASIGNADOS -->
    <!-- ================================================== -->

    <div class="modal-section">
      <div class="section-heading">
        <div>
          <h6 class="section-title">Roles asignados</h6>

          <p class="section-description">
            Roles que actualmente tiene asignados el usuario.
          </p>
        </div>
      </div>

      <div class="custom-table-wrapper">
        <table class="table custom-table roles-table align-middle mb-0">
          <caption class="visually-hidden">
            Roles
          </caption>

          <thead>
            <tr>
              <th scope="col">Rol</th>

              <th scope="col" class="text-center role-action-column">Acción</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let rolUsuario of rolesUsuario; index as i">
              <td>
                <div class="role-info">
                  <div class="role-icon">
                    <i class="fa-solid fa-user-shield"></i>
                  </div>

                  <span class="role-name">
                    {{ rolUsuario.nombre }}
                  </span>
                </div>
              </td>

              <td class="text-center">
                <button
                  type="button"
                  class="btn delete-circle-button"
                  id="trash-rol"
                  (click)="deleteRole(rolUsuario.id)"
                  title="Eliminar rol"
                >
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="!rolesUsuario || rolesUsuario.length === 0">
              <td colspan="2">
                <div class="empty-state">
                  <i class="fa-solid fa-user-shield"></i>

                  <span> No hay roles asignados. </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer custom-modal-footer">
    <button
      type="button"
      class="btn btn-light secondary-button"
      (click)="modal.close('Save click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>

<!-- ============================================================ -->
<!-- MODAL RESTABLECER CONTRASEÑA -->
<!-- ============================================================ -->

<ng-template #resetPasswordModal let-modal>
  <div class="modal-header custom-modal-header">
    <div class="modal-heading">
      <div class="modal-icon modal-icon-warning">
        <i class="fa-solid fa-key"></i>
      </div>

      <div>
        <h4 class="modal-title">
          {{ title }}
        </h4>

        <p class="modal-description">
          Envía una contraseña temporal al usuario.
        </p>
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal-body">
    <!-- ANIMACIÓN -->

    <div class="password-animation">
      <lottie-player
        src="/assets/lottie/forgot_password.json"
        background="transparent"
        speed="1"
        loop
        autoplay
      >
      </lottie-player>
    </div>

    <form [formGroup]="restoreForm">
      <div class="password-info">
        <i class="fa-solid fa-circle-info"></i>

        <span>
          Se enviará un correo a la siguiente dirección con una contraseña
          temporal y solicitud de cambio al iniciar sesión.
        </span>
      </div>

      <div class="field-group mt-3">
        <label class="form-label"> Correo electrónico </label>

        <div class="email-action-box">
          <div class="input-icon-wrapper flex-grow-1">
            <i class="fa-solid fa-envelope"></i>

            <input
              type="text"
              class="form-control"
              placeholder="example@gmail.com"
              aria-label="Correo usuario"
              formControlName="email"
            />
          </div>

          <button
            class="btn send-email-button"
            type="button"
            (click)="sendRecoverPasswordRequest()"
            [disabled]="loadingResetPassword"
          >
            <i *ngIf="!loadingResetPassword" class="fa-solid fa-paper-plane">
            </i>

            <i *ngIf="loadingResetPassword" class="fa-solid fa-spinner fa-spin">
            </i>
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer custom-modal-footer">
    <button
      type="button"
      class="btn btn-light secondary-button"
      (click)="modal.close('Save click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>

<!-- ============================================================ -->
<!-- MODAL IMAGEN FIRMA -->
<!-- ============================================================ -->

<ng-template #imagenModalFirma let-modal>
  <div class="modal-header custom-modal-header">
    <div class="modal-heading">
      <div class="modal-icon modal-icon-cyan">
        <i class="fa-solid fa-signature"></i>
      </div>

      <div>
        <h4 class="modal-title">
          {{ title }}
        </h4>

        <p class="modal-description">
          Configura la imagen utilizada para la firma.
        </p>
      </div>
    </div>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal-body">
    <!-- ================================================== -->
    <!-- PREVIEW -->
    <!-- ================================================== -->

    <div class="signature-preview">
      <div
        class="signature-image-container"
        [style]="scaled ? getStyleContenedorImg(scaled) : null"
      >
        <img
          [src]="imagenUrl"
          alt="Imagen de firma"
          [style]="scaled ? getStyleString(scaled) : null"
          *ngIf="existeImagen"
        />

        <img
          [src]="imagenUrl"
          alt="Imagen de firma"
          class="signature-placeholder-image"
          *ngIf="!existeImagen"
        />
      </div>

      <div class="signature-size-info" *ngIf="existeImagen && scaled">
        <i class="fa-solid fa-ruler-combined"></i>

        <span>
          La imagen para firma tendrá las siguientes medidas:
          {{
            scaled.width +
              " x " +
              scaled.height +
              " escalada al " +
              scaled.scale +
              "%"
          }}
        </span>
      </div>
    </div>

    <!-- ================================================== -->
    <!-- FILE UPLOAD -->
    <!-- ================================================== -->

    <div class="signature-upload">
      <app-file-upload
        #fileUpload
        (fileSelected)="handleFiles($event)"
        [multiple]="false"
        [extension]="['png']"
        [maxFiles]="1"
      >
      </app-file-upload>
    </div>

    <!-- ================================================== -->
    <!-- CONFIGURACIÓN FIRMA -->
    <!-- ================================================== -->

    <form
      [formGroup]="formSignatureSize"
      class="signature-form"
      *ngIf="firmaCustom"
    >
      <div class="section-heading">
        <div>
          <h6 class="section-title">Configuración personalizada</h6>

          <p class="section-description">
            Información de la imagen personalizada.
          </p>
        </div>
      </div>

      <div class="row g-3">
        <!-- NOMBRE -->

        <div class="col-12">
          <div class="field-group">
            <label class="form-label"> Nombre </label>

            <input
              type="text"
              class="form-control"
              placeholder="Ej: Firma estándar - documento A4"
              formControlName="nombre"
            />

            <app-error-message
              [control]="formSignatureSize.get('nombre')"
              errorKey="required"
              message="La firma personalizada necesita un nombre."
            >
            </app-error-message>
          </div>
        </div>

        <!-- NOMBRE CORTO -->

        <div class="col-12 col-md-6">
          <div class="field-group">
            <label class="form-label"> Nombre corto </label>

            <input
              type="text"
              class="form-control"
              placeholder="Ej: estandarA4"
              formControlName="nombre_corto"
              readonly="true"
            />
          </div>
        </div>

        <!-- ANCHO -->

        <div class="col-6 col-md-3">
          <div class="field-group">
            <label class="form-label"> Ancho </label>

            <input
              type="text"
              class="form-control"
              placeholder="Ej: 150"
              formControlName="width"
              readonly="true"
            />
          </div>
        </div>

        <!-- ALTO -->

        <div class="col-6 col-md-3">
          <div class="field-group">
            <label class="form-label"> Alto </label>

            <input
              type="text"
              class="form-control"
              placeholder="Ej: 80"
              formControlName="height"
              readonly="true"
            />
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer custom-modal-footer">
    <button
      type="button"
      class="btn upload-button"
      (click)="subirImagen(fileUpload)"
    >
      <i class="fa-solid fa-cloud-arrow-up me-2"></i>

      Subir documentos
    </button>

    <button
      type="button"
      class="btn btn-light secondary-button"
      (click)="modal.close('Save click')"
    >
      Cerrar
    </button>
  </div>
</ng-template>
